export default __webpack_public_path__ + "static/media/niko.5e10fbf0.jpg";